import React from "react";

export const ResultField: React.FC<{
  label: string;
  value: string;
}> = ({ label, value }) => (
  <div className="flex-grow">
    <div className="text-s md:text-base font-semibold mb-3">{label}</div>
    <div className="text-base font-semibold text-grey-11 bg-white py-4 px-2 md:px-8 border-grey-12 border rounded">
      {value}
    </div>
  </div>
);
